export default "__VITE_ASSET__BybRMRXT__"